<template>
  <div class="z-index-10-fg reports-menu">
    <ul>
      <li
        v-if="user.showGeneralReports"
        @click.stop="
          $router.push({ name: 'customer-report' });
          $emit('closeDropdown');
        ">
        Customer Report
      </li>
      <li
        v-if="user.showGeneralReports"
        @click.stop="
          $router.push({ name: 'company-report' });
          $emit('closeDropdown');
        ">
        Company Report
      </li>
      <li
        v-if="user.showImpactReport"
        @click.stop="
          $router.push({ name: 'sales-impact-report' });
          $emit('closeDropdown');
        ">
        Sales Impact Report
      </li>
    </ul>
  </div>
  <div class="screen-overlay-clear z-index-10-bg" @click.stop="$emit('closeDropdown')"></div>
</template>

<script>
import useCurrentUser from '@/composables/useCurrentUser';

export default {
  name: 'ReportsMenu',
  emits: ['closeDropdown'],
  setup() {
    const { user } = useCurrentUser();

    return {
      user,
    };
  },
};
</script>

<style lang="scss" scoped>
.reports-menu {
  width: 12.5rem;
  left: -0.3rem;
  top: 4.4rem;
  position: absolute;
  background-color: #777777;
  list-style: none;
  border-radius: 0 0 $borderRadius4 $borderRadius4;

  ul {
    list-style-type: none;
    padding: 0.7rem;
    margin: 0;
    font-weight: 400;

    li {
      padding: 0.6rem;
      cursor: pointer;
      color: white;
      text-transform: none;
    }
  }
}
</style>
